import apiClient from '../../../services/apiClient';

export const facilityApi = {
  getFacilities: async (schoolId) => {
    const response = await apiClient.get(`/schools/${schoolId}/facilities/`);
    return response.data.data || response.data;
  }
};
